import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const PTFlagIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <circle cx="10" cy="10" r="10" fill="#408C41" />
      <path
        d="M10.0826 4.5L18.1652 10L10.0826 15.5L2 10L10.0826 4.5Z"
        fill="#FDDF01"
      />
      <circle cx="10" cy="10" r="3" fill="#0C5283" />
    </BaseIcon>
  );
};

PTFlagIcon.displayName = 'PTFlagIcon';
